var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_428_3759)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_428_3759",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6C5.44772 6 5 6.44772 5 7V10C5 10.5523 5.44772 11 6 11L6 21C6 21.5523 6.44772 22 7 22H21C21.5523 22 22 21.5523 22 21V11C22.5523 11 23 10.5523 23 10V7C23 6.44772 22.5523 6 22 6H6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 11H8V9H6V11ZM6 21H4H6ZM22 11V9H20V11H22ZM7 7C7 7.55228 6.55228 8 6 8V4C4.34315 4 3 5.34315 3 7H7ZM7 10V7H3V10H7ZM6 9C6.55228 9 7 9.44771 7 10H3C3 11.6569 4.34315 13 6 13V9ZM8 21L8 11H4L4 21H8ZM7 20C7.55229 20 8 20.4477 8 21H4C4 22.6569 5.34315 24 7 24V20ZM21 20H7V24H21V20ZM20 21C20 20.4477 20.4477 20 21 20V24C22.6569 24 24 22.6569 24 21H20ZM20 11V21H24V11H20ZM21 10C21 9.44771 21.4477 9 22 9V13C23.6569 13 25 11.6569 25 10H21ZM21 7V10H25V7H21ZM22 8C21.4477 8 21 7.55229 21 7H25C25 5.34315 23.6569 4 22 4V8ZM6 8H22V4H6V8Z",
    fill: "white",
    mask: "url(#path-1-inside-1_428_3759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10C12 9.44772 12.4477 9 13 9H15C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H13C12.4477 11 12 10.5523 12 10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_428_3759",
    x: -4,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_428_3759"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_428_3759",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.b6d86b8010d74396b74e9c5425d1b6ae.svg";
export { ForwardRef as ReactComponent };